// Vendors
import React, { useRef, useEffect, useState } from 'react';
import { connectHits } from 'react-instantsearch-dom';
import classnames from 'classnames';

// Config
import { SITE_URL } from '../../config';

// Helpers
import { formatMoney } from '../../lib/utilities';

const RebatesSearchTable = ({ hits, searchState, handleSort }) => {
  const table = useRef();
  const [hasOverflow, setHasOverflow] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // Set listeners
  useEffect(() => {
    window.addEventListener('load', checkOverflow);
    window.addEventListener('scroll', checkOverflow);
    window.addEventListener('resize', checkOverflow);
    if (table.current) table.current.addEventListener('scroll', checkScroll);
  });

  // Reset table scroll on hits change
  useEffect(() => {
    if (table.current) table.current.scroll({ left: 0, behavior: 'smooth' });
  }, [hits]);

  const checkOverflow = () =>
    setHasOverflow(
      table.current && table.current.offsetWidth < table.current.scrollWidth
    );

  const checkScroll = (event) => setIsScrolled(event.target.scrollLeft > 0);

  const handleScrollClick = () => {
    if (table.current) table.current.scroll({ left: 120, behavior: 'smooth' });
  };

  return (
    <div className="section section--sm">
      {hits.length < 1 && searchState.query && (
        <div className="notice notice--error" role="alert">
          No results were found for "<strong>{searchState.query}</strong>".
        </div>
      )}

      {hits.length > 0 && (
        <div
          className={classnames('scrollable-table', {
            'scrollable-table--has-overflow': hasOverflow,
            'scrollable-table--is-scrolled': isScrolled
          })}
        >
          <div className="scrollable-table__scroll">
            <button
              onClick={handleScrollClick}
              className="btn btn--blue module-hover-root"
            >
              <span className="btn__content">
                <span className="btn__arrow arrow arrow--white"></span>
              </span>
            </button>
          </div>

          <table ref={table} className="table table--striped table--responsive">
            <thead>
              <tr>
                {[
                  { label: 'Docket #', slug: 'docket' },
                  { label: 'State Rebate Project Title', slug: 'title' },
                  { label: 'State/Region', slug: 'region' },
                  { label: 'Total Awarded', slug: 'amount' },
                  { label: 'Year Awarded', slug: 'year' },
                  { label: null, slug: null }
                ].map(({ label, slug }, index) => (
                  <th
                    key={index}
                    className="u--white-space-nowrap u--padding-10 u--font-size-sm"
                  >
                    {label && slug && (
                      <button
                        className={classnames('table__column-sort', {
                          [`table__column-sort--${searchState.sort.direction}`]:
                            searchState.sort.column === slug
                        })}
                        onClick={() => handleSort(event, slug)}
                      >
                        {label}
                      </button>
                    )}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {hits.map((hit) => (
                <tr key={hit.post_id}>
                  <td>{hit.docket}</td>
                  <td>{hit.title.replace('&amp;', '&')}</td>
                  <td>{hit.region}</td>
                  <td>{formatMoney(hit.total_amount_awarded)}</td>
                  <td>
                    {hit.award_date && new Date(hit.award_date).getFullYear()}
                  </td>
                  <td>
                    <a href={`${SITE_URL}${hit.url}`} target="_blank">
                      <strong className="u--white-space-nowrap">
                        View Funding Request{' '}
                        <i className="icon perc-icon-arrow-right"></i>
                      </strong>
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default connectHits(RebatesSearchTable);
